<template>
	<div>
		<!--<div class="vh-100 bg-white p-d-72">-->
		<div class="vh-100 bg-white">
			<SOTitleBar
				:page-title="'Tambah Konsumen'"
				:type="'close'"
				:show-search="false"
				@back="back"
			/>
			<div class="content-wrapper main-page showPageDefault flex-100">
				<div class="p-x-20 w-limit flex-1">
					<SOStep :step="1" :total="2"/>

					<div class="f-regular f-16 f-c-black p-d-16">
						Silakan isi data diri konsumen Anda.
					</div>

					<div class="p-d-16">
						<SOInputSelect
							:title="'Terdaftar dari Outlet'"
							:placeholder="'Pilih outlet'"
							:options="optionOutlet"
							:required="true"
							:selected="customer.idoutlet"
							@option-selected="(val) => { customer.idoutlet = val }"
						/>
						<ErrorMessage
							class="error"
							label="Outlet"
							:validation="$v.customer.idoutlet"
						/>
					</div>

					<div class="p-d-16">
						<SOInputRegular
							:title="'Nama'"
							:placeholder="'Nella Kharisma'"
							:validation="'alphanumeric'"
							:required="true"
							v-model="customer.nama"
						/>
						<ErrorMessage
							class="error"
							label="Nama"
							:validation="$v.customer.nama"
						/>
					</div>

					<div class="p-d-16">
						<label class="form-label require">
							Jenis Kelamin
						</label>
						<SOInputRadioBig
							:radio-group="radioJenisKelamin"
							:radio-selected="customer.jenis_kelamin"
							@selected-radio="(val) => { customer.jenis_kelamin = parseInt(val) }"
						/>
						<ErrorMessage
							class="error"
							label="Jenis Kelamin"
							:validation="$v.customer.jenis_kelamin"
						/>
					</div>

					<div class="p-d-16">
						<SOInputSelect
							:title="'Sapaan'"
							:placeholder="'Sapaan'"
							:options="optionSapaan.filter((a) => a.tipeSapaan === parseInt(customer.jenis_kelamin) || a.tipeSapaan === 2)"
							:required="true"
							:selected="customer.sapaan"
							@option-selected="(val) => { customer.sapaan = parseInt(val) }"
						/>
						<ErrorMessage
							class="error"
							label="Sapaan"
							:validation="$v.customer.sapaan"
						/>
					</div>
				</div>

				<div class="p-x-20 w-limit">
					<button class="btn btn-login btn-long" @click="nextStep" :disabled="pageSetting.disbaleBtn.next">
						Berikutnya
					</button>
				</div>
			</div>
			<div class="modal fade" id="modal" role="dialog">
				<div class="modal-dialog modal-lg  bani-modal">
					<div class="modal-content w-limit">
						<div class="modal-header">
							<div class="nav-btn kiri"></div>
							<h5 class="navbar-title text-center">Batal Tambah Konsumen</h5>
							<div class="nav-btn kanan tutup">
								<img src="@/assets/img/x2.svg" data-dismiss="modal" alt="">
							</div>
						</div>
						<div class="modal-body">
							<p>Yakin ingin membatalkan pembuatan data konsumen baru?</p>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
							        @click="cancelCreateCustomer">Ya, Batal
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOStep from "@/so-components/global/ui/SOStep";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputRadioBig from "@/so-components/global/input/SOInputRadioBig";
import ErrorMessage from "@/component-items/ErrorMessage";

import {mapGetters} from "vuex";
import {minLength, required} from "vuelidate/lib/validators";

export default {
	name: "CustomerCreateStep1",
	components: {
		ErrorMessage,
		SOTitleBar,
		SOStep,
		SOInputSelect,
		SOInputRegular,
		SOInputRadioBig,
	},
	computed: {
		...mapGetters("outletModule", {
			outlets: "getOutlet",
		}),
		...mapGetters("customerModule", {
			customer: "getDataCreateCustomer",
		}),
		...mapGetters("metaModule", {
			optionSapaan: "getSapaan",
			radioJenisKelamin: "getJenisKelamin",
		}),
	},
	data() {
		return {
			optionOutlet: [],
			pageSetting: {
				disbaleBtn: {
					next: false
				}
			}
		}
	},
	validations: {
		customer: {
			nama: {
				required,
				minLength: minLength(2),
			},
			idoutlet: {
				required,
			},
			jenis_kelamin: {
				required,
			},
			sapaan: {
				required,
			},
		}
	},
	mounted() {
		this.getSapaan()
		this.getOutlet()
		this.smartTrackingView("add_konsumen_step_1");

	},
	methods: {
		back() {
			$("#modal").modal("show");
		},
		async cancelCreateCustomer() {
			// await this.$store.commit("customerModule/resetDataCreateCustomer")
			// await this.$store.commit("customerModule/resetPagination")
			// await this.$store.commit("customerModule/resetCustomer")
			// await this.$router.push("/konsumen")
			this.$router.back()
		},
		async getSapaan() {
			const res = await this.$store.dispatch("metaModule/fetchSapaan")
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		async getOutlet() {
			const res = await this.$store.dispatch("outletModule/fetchOutletAll")
			if (res.success) {
				for (let i = 0; i < this.outlets.data.length; i++) {
					this.optionOutlet = [...this.optionOutlet, {
						id: this.outlets.data[i].idoutlet,
						text: this.outlets.data[i].nama
					}]
				}
			} else {
				this.$toast.error(res.err)
			}
		},
		errorValidation() {
		  console.log(this.$v)

			this.$v.customer.nama.$touch()
			this.$v.customer.idoutlet.$touch()
			this.$v.customer.jenis_kelamin.$touch()
			this.$v.customer.sapaan.$touch()
			return this.$v.customer.nama.$invalid ||
				this.$v.customer.idoutlet.$invalid ||
				this.$v.customer.jenis_kelamin.$invalid ||
				this.$v.customer.sapaan.$invalid
		},
		validate() {
			this.pageSetting.disbaleBtn.next = !(this.customer.nama !== "" &&
				this.customer.jenis_kelamin !== "" &&
				this.customer.idoutlet !== "" &&
				this.customer.sapaan !== "");
		},
		nextStep() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			this.$router.push("/konsumen/create/2")
			this.smartTrackingClick("add_konsumen_step_2");

		},
	}
}
</script>